import { render, staticRenderFns } from "./music-view.vue?vue&type=template&id=5646d964&"
import script from "./music-view.vue?vue&type=script&lang=js&"
export * from "./music-view.vue?vue&type=script&lang=js&"
import style0 from "./music-view.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports